import React, { Component } from "react";
import { connect } from "react-redux";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import Collapse from "@material-ui/core/Collapse";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Input from "@material-ui/core/Input";
import InputAdornment from "@material-ui/core/InputAdornment";
import SearchIcon from "@material-ui/icons/Search";
import Style from "react-style-tag/lib/Style";
import { getSavedAddresses } from "../../../Helpers/orderPass";

class Provinces extends Component {
  state = {
    openListItems: [],
    search: "",
    preparingData: false,
    selectedDeliveryCharge: 0,
  };

  finalData = null;

  openList = (prov) => {
    let tempItems = this.state.openListItems;
    if (tempItems.includes(prov)) {
      tempItems = tempItems.filter((p) => p !== prov);
    } else tempItems.push(prov);
    this.setState({ openListItems: tempItems });
  };
  prepareData = (data, search = null) => {
    search = search || this.state.search;
    const { language, settings } = this.props;
    if (settings.is_branch_based_ordering) {
      data = data.filter(
        (bdc, index, self) =>
          index ===
          self.findIndex((t) => t.delivery_charge === bdc.delivery_charge)
      );
      data = data.filter(
        (bdc) =>
          bdc.area.toLowerCase().includes(search.toLowerCase()) ||
          bdc.area_ar.includes(search) ||
          bdc.area_ar.replace(/أ/g, "ا").includes(search.replace(/أ/g, "ا")) ||
          (bdc.province != "-,-" &&
            bdc.province.toLowerCase().includes(search.toLowerCase()))
      );
    } else {
      data = data.filter(
        (area) =>
          area.name.toLowerCase().includes(search.toLowerCase()) ||
          area.ar_name.includes(search) ||
          area.ar_name.replace(/أ/g, "ا").includes(search.replace(/أ/g, "ا")) ||
          area.province_name.toLowerCase().includes(search.toLowerCase()) ||
          area.province_ar_name.includes(search) ||
          area.province_ar_name
            .replace(/أ/g, "ا")
            .includes(search.replace(/أ/g, "ا"))
      );
    }

    let finalData = {};
    if (settings.is_branch_based_ordering) {
      data.forEach((bdc) => {
        if (finalData[bdc.province.split(",")[language === "arabic" ? 1 : 0]]) {
          finalData[
            bdc.province.split(",")[language === "arabic" ? 1 : 0]
          ].push(bdc);
        } else {
          finalData[bdc.province.split(",")[language === "arabic" ? 1 : 0]] = [
            bdc,
          ];
        }
      });
    } else {
      data.forEach((area) => {
        if (
          finalData[
            (language === "arabic"
              ? area.province_ar_name
              : area.province_name) || "-"
          ]
        ) {
          finalData[
            (language === "arabic"
              ? area.province_ar_name
              : area.province_name) || "-"
          ].push(area);
        } else {
          finalData[
            (language === "arabic"
              ? area.province_ar_name
              : area.province_name) || "-"
          ] = [area];
        }
      });
    }

    let temp = {};
    const filteredProvinces = this.props.provinces.filter(
      (province) => province.country_id === this.props.selectedCountryID
    );
    filteredProvinces.forEach((prov) => {
      temp[prov[language === "arabic" ? "ar_name" : "name"]] = null;
    });
    Object.keys(finalData).forEach((prov) => {
      temp[prov] = finalData[prov];
    });
    Object.keys(temp).forEach((prov) => {
      if (temp[prov] === null) delete temp[prov];
    });

    finalData = temp;
    this.finalData = finalData;

    return finalData;
  };

  renderProvinceTextColor = (province) => {
    const {
      branch_delivery_charges,
      branchDeliveryChargeID,
      areas,
      settings,
      themeColor,
      language,
    } = this.props;
    const { openListItems } = this.state;

    if (settings.is_branch_based_ordering) {
      return (
        !!branchDeliveryChargeID &&
        !openListItems.includes(province) &&
        branch_delivery_charges
          .find((bdc) => bdc.id === branchDeliveryChargeID)
          ?.province.split(",")?.[language === "arabic" ? 1 : 0] === province &&
        themeColor
      );
    } else {
      return (
        !!branchDeliveryChargeID &&
        !openListItems.includes(province) &&
        areas.find((area) => area.id === branchDeliveryChargeID)?.[
          language === "arabic" ? "province_ar_name" : "province_name"
        ] === province &&
        themeColor
      );
    }
  };

  hexToRgbA = (hex) => {
    var c;
    if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
      c = hex.substring(1).split("");
      if (c.length == 3) {
        c = [c[0], c[0], c[1], c[1], c[2], c[2]];
      }
      c = "0x" + c.join("");
      return (
        "rgba(" + [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(",") + ",1)"
      );
    }
    throw new Error("Bad Hex");
  };

  getTextColor = (hex) => {
    let rgba = this.hexToRgbA(hex);
    rgba = rgba.match(/\d+/g);
    if (rgba[0] * 0.299 + rgba[1] * 0.587 + rgba[2] * 0.114 > 186) {
      return "black";
    } else {
      return "white";
    }
  };

  componentDidUpdate = (prevProps, prevState) => {
    if (this.props.selectedCountryID !== prevProps.selectedCountryID) {
      this.setState({ openListItems: [] });
    }

    if (
      this.state.search !== prevState.search ||
      this.props.language !== prevProps.language ||
      this.props.selectedCountryID !== prevProps.selectedCountryID
    ) {
      const { settings, branch_delivery_charges, areas, selectedCountryID } =
        this.props;
      let data = [];
      if (settings.is_branch_based_ordering)
        data = branch_delivery_charges.filter(
          (bdc) => bdc.country_id === selectedCountryID
        );
      else data = areas.filter((area) => area.country === selectedCountryID);
      this.prepareData(data, this.state.search);
      this.setState({
        openListItems: !!this.state.search
          ? Object.keys(this.finalData).slice(0, 5)
          : [],
      });
    }
  };

  render() {
    const { openListItems } = this.state;
    const {
      branch_delivery_charges,
      language,
      settings,
      themeColor,
      selectedCountryID,
      branchDeliveryChargeID, // can be used to store area id for store based
      areas,
    } = this.props;
    const savedAddresses = getSavedAddresses(
      this.props.auth,
      this.props.orderPassAddresses,
      settings,
    );
    if (settings.is_branch_based_ordering && !branch_delivery_charges?.length)
      return <></>;
    if (!settings.is_branch_based_ordering && !areas?.length) return <></>;
    let data = [];
    if (settings.is_branch_based_ordering)
      data = branch_delivery_charges.filter(
        (bdc) => bdc.country_id === selectedCountryID
      );
    else data = areas.filter((area) => area.country === selectedCountryID);
    if (!data.length) {
      return (
        <p className="mt-4">
          {language === "arabic"
            ? "التوصيل حاليا غير متاح"
            : "Delivery is currently not available"}
        </p>
      );
    }
    if (!this.finalData) this.finalData = this.prepareData(data);
    return (
      <>
        <Style>
          {`.MuiInput-underline:before {
                  border-bottom: 1px solid #dee2e6 !important;
              }`}
        </Style>
        <Input
          placeholder={language === "arabic" ? "ابحث ..." : "Search..."}
          inputProps={{ "aria-label": "search" }}
          style={{ width: "100%", padding: "7px 9px" }}
          startAdornment={
            <InputAdornment position="start">
              <SearchIcon style={{ color: "grey" }} />
            </InputAdornment>
          }
          onChange={(e) =>
            this.setState({
              search: e.target.value || "",
            })
          }
        />
        <List
          component="nav"
          aria-labelledby="nested-list-subheader"
          style={{ width: "100%" }}
        >
          {Object.keys(this.finalData).map((province) => (
            <>
              <ListItem
                button
                onClick={() => this.openList(province)}
                style={{ textAlign: language === "arabic" ? "right" : "left" }}
              >
                <ListItemText
                  primary={
                    <span
                      className="bold"
                      style={{
                        color: this.renderProvinceTextColor(province),
                      }}
                    >
                      {province}
                    </span>
                  }
                />
                {openListItems.includes(province) ? (
                  <ExpandLess />
                ) : (
                  <ExpandMore />
                )}
              </ListItem>

              <Collapse
                in={openListItems.includes(province)}
                timeout="auto"
                unmountOnExit
              >
                <List component="div" disablePadding>
                  {this.finalData[province].map((bdc) => (
                    <ListItem
                      button
                      style={{
                        [`padding${
                          language === "arabic" ? "Right" : "Left"
                        }`]: 35,
                        textAlign: language === "arabic" ? "right" : "left",
                        backgroundColor:
                          branchDeliveryChargeID === bdc.id ||
                          this.state.selectedDeliveryCharge ===
                            bdc.delivery_charge
                            ? themeColor
                            : "transparent",
                        color:
                          branchDeliveryChargeID === bdc.id ||
                          this.state.selectedDeliveryCharge ===
                            bdc.delivery_charge
                            ? this.getTextColor(themeColor)
                            : "black",
                        width: "97%",
                        margin: "auto",
                        borderRadius: 4,
                      }}
                      onClick={() => {
                        if (
                          settings.is_branch_based_ordering &&
                          bdc.other_branch_delivery_charges.length > 1
                        ) {
                          if (
                            settings.enable_branch_prioritization_staff &&
                            settings.enable_branch_prioritization
                          ) {
                            let bdcs = branch_delivery_charges.filter(
                              (bd) =>
                                bd.delivery_charge == bdc.delivery_charge &&
                                !bd.branch_is_busy
                            );
                            if (bdcs.length) {
                              let sortedBdcs = bdcs.sort(
                                (a, b) => b.branch_priority - a.branch_priority
                              );
                              let uniqueBdcs = [
                                ...new Set(
                                  sortedBdcs.map((b) => b.branch_priority)
                                ),
                              ];
                              if (sortedBdcs.length !== uniqueBdcs.length) {
                                this.props.OpenBranchSelectDrawer(
                                  bdc.delivery_charge
                                );
                              } else {
                                this.setState({
                                  selectedDeliveryCharge: bdc.delivery_charge,
                                });
                                this.props.setBranchDeliveryChargeID(
                                  sortedBdcs[0].id
                                );
                              }
                            } else {
                              this.props.OpenBranchSelectDrawer(
                                bdc.delivery_charge
                              );
                            }
                          } else
                            this.props.OpenBranchSelectDrawer(
                              bdc.delivery_charge
                            );
                        } else {
                          if (savedAddresses.length) {
                            let tempFoundAddress;
                            if (settings.is_branch_based_ordering) {
                              tempFoundAddress = savedAddresses.find(
                                (adrs) =>
                                  adrs.branch_delivery_charge_id === bdc.id
                              );
                            } else {
                              tempFoundAddress = savedAddresses.find(
                                (adrs) => adrs.area_id === bdc.id
                              );
                            }

                            if (tempFoundAddress) {
                              this.setState({ selectedDeliveryCharge: 0 });
                              this.props.setBranchDeliveryChargeID(bdc.id);
                              this.props.setAddressesOpen();
                            } else {
                              this.setState({ selectedDeliveryCharge: 0 });
                              this.props.setBranchDeliveryChargeID(bdc.id);
                            }
                          } else {
                            this.setState({ selectedDeliveryCharge: 0 });
                            this.props.setBranchDeliveryChargeID(bdc.id); //bdc here is an area object
                          }
                        }
                      }}
                    >
                      <ListItemText
                        primary={
                          language === "arabic"
                            ? settings.is_branch_based_ordering
                              ? bdc.area_ar
                              : bdc.ar_name
                            : settings.is_branch_based_ordering
                            ? bdc.area
                            : bdc.name
                        }
                      />
                    </ListItem>
                  ))}
                </List>
              </Collapse>
            </>
          ))}
        </List>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    countries: state.store.store.countries,
    language: state.store.language,
    settings: state.store.store.settings,
    branch_delivery_charges: state.store.store.branch_delivery_charges,
    themeColor: state.store.store.settings.dark || "#0099cc",
    auth: state.auth,
    orderPassAddresses: state.customers.orderPassAddresses || [],
    areas: state.store.store.areas,
    provinces: state.store.store.provinces,
  };
};

export default connect(mapStateToProps)(Provinces);
